// Centralized motion tokens — purposeful, consistent timing & easing
// "Premium motion = simple movement, intentional sequencing"

export const easing = {
    primary: [0.65, 0, 0.35, 1], // smooth in/out — main reveal
    soft: [0.22, 1, 0.36, 1], // expo-out — slow settle
    enter: [0.16, 1, 0.3, 1], // dramatic entrance
};

export const durations = {
    instant: 0.18,
    fast: 0.45,
    base: 0.7,
    slow: 1.1,
    slower: 1.6,
};

// Reusable variants
export const fadeUp = (delay = 0) => ({
    initial: { opacity: 0, y: 32 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: durations.base, delay, ease: easing.primary },
});

export const fadeIn = (delay = 0) => ({
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: durations.slow, delay, ease: easing.primary },
});

export const charReveal = (delay = 0) => ({
    initial: { y: "110%", rotateX: 90, opacity: 0 },
    animate: { y: "0%", rotateX: 0, opacity: 1 },
    transition: {
        duration: durations.base,
        delay,
        ease: easing.enter,
    },
});

// Split a string into char-level motion children (preserve spaces)
export const splitChars = (text) => {
    return text.split("").map((ch, i) => ({
        ch,
        key: `${ch}-${i}`,
        delay: i * 0.035,
    }));
};
